// extracted by mini-css-extract-plugin
export default {"container":"vJ-z","dimension":"wJ-z","dimensionLabels":"xJ-z"};